module.exports = __webpack_public_path__ + "static/media/dropdownIcon.1170f212.svg";